//* 动画库
import { gsap } from "gsap";
//* 组件属性
import type { ModulesProps } from "./index";
//* 样式
import css from "../style/index.module.less";

export const useComposable = (define: ModulesProps) => {
    //* 静态变量
    const vars = { size: 0 }; //* 缓存中文名称的尺寸

    //* 响应式变量
    const refs = {
        //* 导航
        navigationKey: ref<number>(0),
        navigationIsMove: ref<boolean>(false),
        navigationDirection: ref<string>("right"),
    };

    //* 节点
    const nodes = {
        header: ref<HTMLElement>(),
        container: ref<HTMLElement>(),
        navigations: ref<HTMLElement>(),
    };

    //* 函数列表
    const methods = {
        //* 初始化函数
        init: () => {
            //* 注册页面滚动事件
            window.addEventListener("scroll", methods.scrollNavigationHandler);
            //* 注册宽度观察者
            if (nodes.container.value) {
                useResizeWObserver(nodes.container.value, () => {
                    //* 检测是否满足运行条件
                    if (!nodes.navigations.value) return;
                    //* 检测是否需要还原导航滚动位置
                    if (nodes.navigations.value.scrollWidth > nodes.navigations.value.offsetWidth) {
                        refs.navigationIsMove.value = true;
                        methods.scrollNavigationHandler();
                    } else {
                        refs.navigationDirection.value = "right";
                        refs.navigationIsMove.value = false;
                        nodes.navigations.value.scrollTo({ left: 0, behavior: "smooth" });
                    }

                    //* 中文翻译的当前状态
                    const config = { size: 0, node: nodes.header.value?.querySelector(`.${css.name_zh}`) as HTMLDivElement | undefined };
                    if (config.node && nodes.header.value) {
                        config.size = config.node.offsetHeight;
                        config.node.style.height = "auto";
                        vars.size = config.node.offsetHeight;
                        nodes.header.value.style.height = "auto";
                        nodes.header.value.style.height = nodes.header.value.offsetHeight + "px";
                        if (!config.size) {
                            config.node.style.height = "0px";
                        }
                    }
                });
            }
        },

        //* 页面滚动导航回调
        scrollNavigationHandler: () => {
            //* 数据初始化
            const result = { index: 0 }; //* 导航索引
            const config = {
                node: nodes.header.value?.querySelector(`.${css.name_zh}`) as HTMLDivElement | undefined, //* 中文名称节点
                width: nodes.navigations.value?.offsetWidth || 0, //* 导航的宽度
                height: nodes.header.value?.offsetHeight || 0, //* 顶部默认高度
            };

            //* 检测页面滚动距离判断中文名称显示状态
            if (config.node) {
                if (scrollY < innerHeight / 2) gsap.to(config.node, { height: "auto", duration: 0.3 });
                else {
                    config.height -= vars.size;
                    gsap.to(config.node, { height: 0, duration: 0.3 });
                }
            }

            //* 通过页面滚动距离计算当前导航索引
            computeds.navigations.value.forEach((value, index) => {
                const rect = value.ref?.$el?.getBoundingClientRect();
                //* rect.top 偶尔会出现浮点数值误差
                if (rect && rect.top - 1 <= config.height) {
                    result.index = index;
                }
            });

            //* 索引更新
            refs.navigationKey.value = result.index;
            //* 检测索引位置，判断导航是否定位
            const node = nodes.navigations.value?.children[result.index] as HTMLElement;
            if (node) {
                if (node.offsetLeft + node.offsetLeft >= config.width) methods.openNavigationRight();
                else {
                    methods.openNavigationLeft();
                }
            }
        },

        //* 开启滚动
        openNavigation: (node?: any) => {
            if (node && node.$el) {
                //* 计算页面滚动的位置
                const result = { offset: (node.$el?.offsetTop || 0) - (nodes.header.value?.offsetHeight || 0) + 64 };
                if (result.offset >= innerHeight / 2) {
                    result.offset += vars.size;
                }

                //* 触发滚动
                scrollTo({ top: result.offset, behavior: "smooth" });
            }
        },

        //* 开启导航栏滚动到左侧
        openNavigationLeft: () => {
            refs.navigationDirection.value = "right";
            nodes.navigations.value?.scrollTo({ left: 0, behavior: "smooth" });
        },

        //* 开启导航栏滚动到右侧
        openNavigationRight: () => {
            if (!nodes.navigations.value) return;
            else {
                refs.navigationDirection.value = "left";
                nodes.navigations.value?.scrollTo({
                    behavior: "smooth",
                    left: nodes.navigations.value.scrollWidth - nodes.navigations.value.offsetWidth,
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        //* 导航排序
        navigations: computed(() => {
            if (!define.navigations?.length) return [];
            else {
                return define.navigations.sort((a, b) => a.index - b.index);
            }
        }),

        //* 左侧导航控制器
        navigationIsLeft: computed(() => {
            return refs.navigationIsMove.value && refs.navigationDirection.value == "left";
        }),

        //* 左侧导航控制器
        navigationIsRight: computed(() => {
            return refs.navigationIsMove.value && refs.navigationDirection.value == "right";
        }),
    };

    return { refs, nodes, methods, computeds };
};
